// removed by extract-text-webpack-plugin
module.exports = {"textSliderWrapper":"text-slider__textSliderWrapper___3zzgn","gradient":"text-slider__gradient___-P0Q4","textSlider":"text-slider__textSlider___237Al"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/TextSlider/text-slider.scss
// module id = 944
// module chunks = 0